const STORAGE_KEY = "amg-lang";

export const LOCALES = {
  en: { id: "en", dir: "ltr", label: "EN" },
  ar: { id: "ar", dir: "rtl", label: "العربية" },
};

export function isLocale(value) {
  return value === "en" || value === "ar";
}

export function readStoredLocale() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (isLocale(stored)) return stored;
  } catch (_err) {
    /* ignore private-mode storage */
  }
  return "en";
}

export function storeLocale(locale) {
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch (_err) {
    /* ignore */
  }
}

export function applyDocumentLocale(locale) {
  const meta = LOCALES[locale] || LOCALES.en;
  document.documentElement.lang = meta.id;
  document.documentElement.dir = meta.dir;
  document.title = locale === "ar" ? "إيه إم جلوبال" : "AM Global";
}

export function translate(messages, key) {
  const value = key.split(".").reduce((acc, part) => {
    if (acc == null) return null;
    return acc[part];
  }, messages);
  return typeof value === "string" ? value : key;
}
